export const buildQueryParams = (queryParams: any) =>
    Object.keys(queryParams).length > 0
        ? Object.keys(queryParams).reduce(
              (str, key, i) => `${str}${key}=${queryParams[key]}${i < Object.keys(queryParams).length - 1 ? '&' : ''}`,
              '?'
          )
        : '';
